/**
 * External dependencies
 */
import React from 'react';

import ContentLoader from 'react-content-loader';

/**
 * Internal dependencies
 */
import { Card, Stack } from '@towersystems/towersystems-design-system';

const CloudHostingPlanLoader = () => {
    return (
        <Card>
            <Stack dividers>
                <ContentLoader speed={2} height={50} width='100%' backgroundColor='#f3f3f3' foregroundColor='#ecebeb'>
                    <rect x='70' y='8' rx='3' ry='3' width='50%' height='10' />
                    <rect x='70' y='26' rx='3' ry='3' width='35%' height='10' />
                    <circle cx='25' cy='20' r='18' />
                </ContentLoader>
                <ContentLoader speed={2} height={30} width='100%' backgroundColor='#f3f3f3' foregroundColor='#ecebeb'>
                    <rect x='0' y='0' rx='3' ry='3' width='35%' height='10' />
                    <rect x='0' y='20' rx='3' ry='3' width='100%' height='10' />
                </ContentLoader>
                <ContentLoader speed={2} height={30} width='100%' backgroundColor='#f3f3f3' foregroundColor='#ecebeb'>
                    <rect x='0' y='10' rx='3' ry='3' width='100%' height='10' />
                </ContentLoader>
                <ContentLoader speed={2} height={30} width='100%' backgroundColor='#f3f3f3' foregroundColor='#ecebeb'>
                    <rect x='0' y='12' rx='3' ry='3' width='100%' height='10' />
                </ContentLoader>
            </Stack>
        </Card>
    );
};

export default CloudHostingPlanLoader;
